import Vue from 'vue'
import VueI18n from 'vue-i18n'
import es from 'vee-validate/dist/locale/es.json'
import en from 'vee-validate/dist/locale/en.json'
import it from 'vee-validate/dist/locale/it.json'
import de from 'vee-validate/dist/locale/de.json'
import fr from 'vee-validate/dist/locale/fr.json'
const messages = require('./i18nData.json')

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en', // set default locale
  messages: {
    en: {
      ...messages.en,
      validation: en.messages,
      fields: {
        email: 'email',
        password: 'password'
      }
    },
    fr: {
      ...messages.fr,
      validation: fr.messages,
      fields: {
        email: 'email',
        password: 'password'
      }
    },
    de: {
      ...messages.de,
      validation: de.messages,
      fields: {
        email: 'email',
        password: 'password'
      }
    },
    es: {
      ...messages.es,
      validation: es.messages,
      fields: {
        email: 'email',
        password: 'password'
      }
    },
    it: {
      ...messages.it,
      validation: it.messages,
      fields: {
        email: 'email',
        password: 'password'
      }
    }
  }
})
export { i18n }
